import Cookies from 'js-cookie'

const TokenKey = 'token'
// const routeKey='requstPaths'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
// export function getRoute() {
//   return Cookies.get(routeKey)
// }

// export function setRoute(requstPaths) {
//   return Cookies.set(routeKey, requstPaths)
// }

// export function removeRoute() {
//   return Cookies.remove(routeKey)
// }